import { Badge } from "react-bootstrap"
import Link from "next/link"
import { PlayCircle, PlayFill } from "react-bootstrap-icons"
import { ActivityCard, SkillBadge, LiveBadge } from "../styled/Activity"
import { PublicActivityPageQueriesQuery, PublicWorkshopQuery } from "@generated/graphql"

interface Props {
  showButton?: "play" | "live"
  item: PublicActivityPageQueriesQuery["publicChallengeActivities"][0] | PublicActivityPageQueriesQuery["publicLiveActivities"][0] | PublicActivityPageQueriesQuery["publicNewReleaseActivities"][0] | PublicActivityPageQueriesQuery["publicPopularActivities"][0] | NonNullable<NonNullable<PublicWorkshopQuery["publicWorkshop"]>["insiderActivities"]>[0]
}

const colors = ["#FECC06", "#FF9CA1", "#C9E726", "#71E1EF"]

export default function ActivityCardItem({ item, showButton }: Props) {
  return (
    <Link href={`/skills/${item.skill?.slug}/${item?.slug}`} legacyBehavior>
      <ActivityCard>
        <div style={{ position: "relative" }}>
          <img src={item?.featuredImage || "/assets/img/logo.png"} height={showButton === "live" ? "260px" : "180px"} style={{ objectFit: showButton === "live" ? "cover" : "inherit" }} width="100%" />
          {item.skill && <Link href={`/skills/${item.skill?.slug}`} legacyBehavior><SkillBadge pill bg="light" text="dark" color={colors[item.skill.id % colors.length]}>{item.skill?.name || ""}</SkillBadge></Link>}
          {showButton ? showButton === "play" ? <PlayCircle style={{ position: "absolute", bottom: "8px", left: "8px" }} color="white" size={40} />
            : <LiveBadge pill>LIVE<PlayFill /></LiveBadge>
            : null}
        </div>
        <div style={{ marginLeft: "8px", padding: "8px" }}>
          <h4>{item.title}</h4>
          <span>{item.difficultyLevel}</span>
          <img height="18px" src="/assets/img/camera.png" style={{ marginLeft: "12px", display: "inline" }} />
          <span style={{ marginLeft: "4px" }}>{item.commentsCount || 0}</span>
          <img height="18px" src="/assets/img/clock.png" style={{ marginLeft: "12px", display: "inline" }} />
          <span style={{ marginLeft: "4px" }}>{item.timeRequired}</span>
        </div>
      </ActivityCard>
    </Link>
  )
}
